import { TimezoneApi } from 'api/TimezoneApi';
import { backendApiClient } from 'container/backendApiClient';

export const timezoneApi = new TimezoneApi(backendApiClient);
